export const messages = {
  prepare: 'Functional update in progress. System stability may be affected.',
  finish: 'A planned functional update is scheduled today at 19:00 (UTC). During this time system stability may be affected.',
  upgrading_servers: 'Please note that we are upgrading servers capacity and stats on UI might be not accessible.\n' +
    'We are recording the numbers and trade activity is not affected. You will see the numbers for this time period later.',
  new_report: `New stats reports arrived! Please note that new stats tab
    will show the numbers starting from the moment of delpoy, it does not store older data.\n` +
    'Please check your email updates or Knowledge Base on UI to get the details.',
};
